// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"bcf0676f594fd069b34c","453":"a1a1bf520d8f9e52c5ee","577":"00275550528845ac53b3"}[chunkId] + ".js";
};